import { render, staticRenderFns } from "./payAction.vue?vue&type=template&id=33d443cf&scoped=true&"
import script from "./payAction.vue?vue&type=script&lang=js&"
export * from "./payAction.vue?vue&type=script&lang=js&"
import style0 from "./payAction.vue?vue&type=style&index=0&id=33d443cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d443cf",
  null
  
)

export default component.exports